/**
 * 個人情報をマスキングするユーティリティ関数
 */

/**
 * メールアドレスをマスキング
 * 例: test@example.com → te**@ex*****.com
 */
export const maskEmail = (email: string): string => {
  if (!email || !email.includes("@")) return email;

  const [localPart, domain] = email.split("@");

  // ローカル部分（@の前）: 最初の2文字以外をマスク
  const maskedLocal =
    localPart.length <= 2
      ? localPart
      : localPart.substring(0, 2) +
        "*".repeat(Math.min(localPart.length - 2, 4));

  // ドメイン部分: 最初の2文字以外をマスク（ただし.の後は表示）
  const domainParts = domain.split(".");
  const maskedDomainFirst =
    domainParts[0].length <= 2
      ? domainParts[0]
      : domainParts[0].substring(0, 2) +
        "*".repeat(Math.min(domainParts[0].length - 2, 5));

  const maskedDomain = [maskedDomainFirst, ...domainParts.slice(1)].join(".");

  return `${maskedLocal}@${maskedDomain}`;
};

/**
 * ユーザー名・名前をマスキング
 * 例: 山田太郎 → 山田**
 */
export const maskName = (name: string): string => {
  if (!name) return name;

  // 2文字以下ならそのまま表示
  if (name.length <= 2) return name;

  // 最初の2文字以外をマスク
  return name.substring(0, 2) + "*".repeat(Math.min(name.length - 2, 4));
};

/**
 * 管理者権限でマスキングを解除するためのstate管理用
 */
export const createMaskedData = <T extends Record<string, any>>(
  data: T,
  fields: { field: keyof T; type: "email" | "name" }[]
): T => {
  const masked = { ...data };
  fields.forEach(({ field, type }) => {
    const value = data[field];
    if (typeof value === "string") {
      masked[field] = (
        type === "email" ? maskEmail(value) : maskName(value)
      ) as T[keyof T];
    }
  });
  return masked;
};
